import { render } from "./AddTokenModal.vue?vue&type=template&id=c114f1f6&scoped=true"
import script from "./AddTokenModal.vue?vue&type=script&lang=js"
export * from "./AddTokenModal.vue?vue&type=script&lang=js"

import "./AddTokenModal.vue?vue&type=style&index=0&id=c114f1f6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c114f1f6"

export default script